import { useState, useEffect, useCallback, useMemo } from "react";

import { getCroppedImg } from "../images";
import { uploadBase64Image } from "../s3-images";

const useAvatarUrl = (file) => {
  const [avatarUrl, setAvatarUrl] = useState("");

  useEffect(() => {
    if (!file) return;

    uploadBase64Image(file, 'user-images')
      .then((data) => setAvatarUrl(data.url))
      .catch((err) => console.error("Avatar upload failed:", err));
  }, [file]);

  return avatarUrl;
};

const useCropImage = (imagePreviewUrl) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [croppedFile, setCroppedFile] = useState(null);
  const avatarUrl = useAvatarUrl(croppedFile);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const [croppedImage, file] = await getCroppedImg(
        imagePreviewUrl,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
      setCroppedFile(file);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation, imagePreviewUrl]);

  return useMemo(
    () => ({
      crop,
      setCrop,
      setRotation,
      zoom,
      setZoom,
      croppedImage,
      avatarUrl,
      onCropComplete,
      showCroppedImage,
      setCroppedFile,
      setCroppedImage,
      rotation,
    }),
    [
      crop,
      croppedImage,
      onCropComplete,
      avatarUrl,
      rotation,
      showCroppedImage,
      zoom,
    ]
  );
};

export default useCropImage;
